(function($) {

    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh+ 'px');

    $(window).on('resize', function() {
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh+ 'px');
    })

    $('header .hamburger').on('click', function() {
        $('html, body').animate({ scrollTop: 0 }, 300);
        $('body').toggleClass('overflow-hidden');
        $(this).toggleClass('active');
        $(this).closest('header').toggleClass('active');
    });

    $('header .submenu-trigger').on('click', function() {
        $(this).toggleClass('active');
        $(this).next().slideToggle();
    })

    $('header .menu-top .full-toggle > a').on('click', function(e) {
        e.preventDefault();
    })

    $('header .mobile-menu .full-toggle').on('click', function(e) {
        if ($(e.target).parent('.full-toggle').length) {
            e.preventDefault();
            $(this).find('.submenu-trigger').toggleClass('active');
            $(this).find('.sub-menu').slideToggle();
        }
    });

    $(window).on('scroll', function() {
        var windowY = window.pageYOffset;

        if (windowY >= 150) {
            $('header').addClass('scrolled');
        } else {
            $('header').removeClass('scrolled');
        }
    });

})( jQuery );